var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIospushBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8315 15.3581C9.99151 16.2024 9.07439 16.0691 8.19156 15.6691C7.2573 15.2603 6.40018 15.2425 5.41449 15.6691C4.18024 16.2202 3.52883 16.0602 2.79171 15.3581C-1.39104 10.8875 -0.773912 4.07948 3.97453 3.83063C5.13164 3.89284 5.93733 4.48832 6.61446 4.54165C7.62586 4.32834 8.59441 3.71509 9.67438 3.79508C10.9686 3.90173 11.9457 4.435 12.5886 5.39487C9.91437 7.05689 10.5486 10.7098 13 11.7319C12.5114 13.065 11.8772 14.3893 10.8229 15.367L10.8315 15.3581ZM6.52875 3.7773C6.40018 1.79533 7.95157 0.15998 9.73438 0C9.98294 2.29304 7.72871 3.9995 6.52875 3.7773Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIospushBlue);
export default __webpack_public_path__ + "static/media/iospushBlue.12e57f3306362a96cf96aa62a8b8e125.svg";
export { ForwardRef as ReactComponent };